// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3P48X","colCheckbox":"styles_colCheckbox__2zcQ0"};